import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
//Antd
import { Col, Divider, Layout, Row, Tabs } from "antd";
import { IdcardOutlined, LaptopOutlined } from "@ant-design/icons";
// import { FolderOutlined } from "@ant-design/icons";
import { BookOutlined, UsergroupDeleteOutlined } from "@ant-design/icons";
//Components
import { DatosAspirantePage, ReqAcademicoPage, ExperienciaPage } from "./";
import { TipoAspiranteProtestoComponent } from "./TipoAspiranteProtesto";
import { cleanState } from "../../../redux/aspirante/reqAcademicoDuck";
import { cleanStateLab } from "../../../redux/aspirante/expLaboralDuck";
import { setTabAspirante } from "../../../redux/aspirante/aspiranteDucks";
import {
  obtenerSistemaINE,
  obtenerSistemaOPLE
} from "../../../redux/consultavacantes/sistemasDucks";
import { AlertGeneric, INFO_POSTULACION } from "../../../utils";

import "./MiPerfilMainPage.css";
import { getEstatusBloqueo } from "../../../redux/aspirante/bloquearAspiranteDucks";
// import { ExpedientePage } from "./ExpedientePage";

const { TabPane } = Tabs;

export const MiPerfilPage = () => {
  
    const dispatch = useDispatch();
    //Para llevar el control entre los tab
    const { tabAspirante } = useSelector((state) => state.aspirante);
    const { isConsulta } = useSelector((state) => state.aspirante.consulta);
    const {
        sistemaINE,
        sistemaOPLE
    } = useSelector((state) => state.sistemas);

    useEffect(() => {
        //Se obtiene el bloqueo por el número de postulaciones o por fechas del concurso
        dispatch(getEstatusBloqueo());
        dispatch(obtenerSistemaINE());
        dispatch(obtenerSistemaOPLE());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //Se limpia el state de Req. Académicos
    useEffect(() => {
        return () => {
        dispatch(cleanState());
        dispatch(setTabAspirante("1"));
        dispatch(cleanStateLab());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChange = (key) => {
        dispatch(setTabAspirante(key));
    };

    const InfoGeneral = ({ isAlert, isModifica }) => {
        return (
        <div style={{ marginLeft: 15, marginRight: 15 }}>
            <div className="info-aspirante">
            Información de la persona aspirante
            </div>
            {isModifica && (
            <div className="info-captura">Captura la siguiente información</div>
            )}
            {isAlert && <AlertGeneric type="info" message={INFO_POSTULACION} />}
        </div>
        );
    };

    return (
        <Layout className="site-layout layout-content">
            <div className="site-layout-content-admin">
                <Row>
                    <Col span={24}>
                        <h1 className="titulo-color">Mi información</h1>
                        <Divider id="titulo-divider" />
                    </Col>
                </Row>
                <div className="content-datos">
                    <Tabs
                        defaultActiveKey={tabAspirante}
                        activeKey={tabAspirante}
                        id="miPerfil"
                        onChange={onChange}
                        className="tab-principal"
                        centered
                        destroyInactiveTabPane
                    >
                        <TabPane
                            tab={
                                <>
                                    <IdcardOutlined style={{ fontSize: 18 }} />
                                    Datos de la persona aspirante
                                </>
                            }
                            key="1"
                        >
                            <InfoGeneral isModifica={!isConsulta} />
                            <DatosAspirantePage />
                        </TabPane>
                        <TabPane
                            tab={
                                <>
                                    <BookOutlined style={{ fontSize: 18 }} />
                                    Información académica
                                </>
                            }
                            key="2"
                            >
                            <ReqAcademicoPage />
                        </TabPane>
                        <TabPane
                            tab={
                                <>
                                    <LaptopOutlined style={{ fontSize: 18 }} />
                                    Experiencia laboral
                                </>
                            }
                            key="3"
                        >
                            <ExperienciaPage />
                        </TabPane>
                        {sistemaINE !== undefined && (
                            <TabPane
                                tab={
                                    <>
                                        <UsergroupDeleteOutlined style={{ fontSize: 18 }} />
                                        Tipo de aspirante y protesto INE
                                    </>
                                }
                                key="4"
                            >
                                <TipoAspiranteProtestoComponent idSistema={sistemaINE.idSistema} />
                            </TabPane>
                        )}
                        {sistemaOPLE !== undefined && (
                            <TabPane
                                tab={
                                    <>
                                        <UsergroupDeleteOutlined style={{ fontSize: 18 }} />
                                        Tipo de aspirante y protesto OPLE
                                    </>
                                }
                                key="5"
                            >
                                <TipoAspiranteProtestoComponent idSistema={sistemaOPLE.idSistema}/>
                            </TabPane>
                        )}
                        {/* <TabPane
                        tab={
                            <>
                            <FolderOutlined style={{ fontSize: 18 }} />
                            Expediente digital
                            </>
                        }
                        key="5"
                        >
                        <ExpedientePage />
                        </TabPane> */}
                    </Tabs>
                </div>
            </div>
        </Layout>
    );
};
